import { render, staticRenderFns } from "./FishSkillIconComponent.vue?vue&type=template&id=511d092e&"
import script from "./FishSkillIconComponent.vue?vue&type=script&lang=ts&"
export * from "./FishSkillIconComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FishSkillIconComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports